import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ChatBlock.styled';
import Icon from '../../atoms/Icon/Icon';
import TextLabel, { TextLabelTypes } from '../../atoms/TextLabel/TextLabel';

const diagIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3077 11.0385C18.3077 13.3808 16.45 15.0662 15.5562 15.8846L15.2977 16.1162C15.1497 16.379 15.0736 16.6761 15.0769 16.9777C15.0769 17.2633 14.9635 17.5372 14.7615 17.7392C14.5595 17.9412 14.2856 18.0546 14 18.0546C13.7144 18.0546 13.4405 17.9412 13.2385 17.7392C13.0365 17.5372 12.9231 17.2633 12.9231 16.9777C12.9127 16.1088 13.2168 15.2654 13.7792 14.6031C13.86 14.5169 13.9731 14.4146 14.1077 14.2908C14.7754 13.6931 16.1538 12.4438 16.1538 11.06C16.1729 10.7722 16.1302 10.4837 16.0287 10.2138C15.9272 9.94381 15.7692 9.69866 15.5653 9.49473C15.3613 9.2908 15.1162 9.13279 14.8462 9.03129C14.5763 8.92978 14.2878 8.88712 14 8.90615C13.7122 8.88712 13.4237 8.92978 13.1538 9.03129C12.8838 9.13279 12.6387 9.2908 12.4347 9.49473C12.2308 9.69866 12.0728 9.94381 11.9713 10.2138C11.8698 10.4837 11.8271 10.7722 11.8462 11.06C11.8462 11.3456 11.7327 11.6195 11.5307 11.8215C11.3288 12.0235 11.0549 12.1369 10.7692 12.1369C10.4836 12.1369 10.2097 12.0235 10.0077 11.8215C9.80577 11.6195 9.69231 11.3456 9.69231 11.06C9.67358 10.4892 9.7722 9.92072 9.98205 9.38962C10.1919 8.85851 10.5085 8.37613 10.9123 7.97233C11.3161 7.56853 11.7985 7.2519 12.3296 7.04205C12.8607 6.83219 13.4292 6.73358 14 6.75231C14.5689 6.73373 15.1356 6.83172 15.6652 7.04027C16.1948 7.24881 16.6761 7.56349 17.0796 7.96496C17.4831 8.36643 17.8002 8.8462 18.0114 9.37475C18.2226 9.90331 18.3234 10.4695 18.3077 11.0385ZM14.5977 19.2985C14.5397 19.2592 14.4785 19.2249 14.4146 19.1962C14.3482 19.1708 14.2797 19.151 14.21 19.1369C14.0521 19.1055 13.8892 19.1099 13.7332 19.1497C13.5772 19.1896 13.4321 19.2639 13.3087 19.3672C13.1852 19.4706 13.0865 19.6002 13.0197 19.7468C12.953 19.8933 12.92 20.0529 12.9231 20.2138C12.9151 20.2836 12.9151 20.3541 12.9231 20.4238C12.9371 20.4936 12.9569 20.562 12.9823 20.6285C13.0111 20.6923 13.0453 20.7536 13.0846 20.8115C13.123 20.8707 13.1662 20.9265 13.2139 20.9785C13.3188 21.077 13.4424 21.1535 13.5775 21.2035C13.7125 21.2534 13.8562 21.2758 14 21.2692C14.0698 21.2772 14.1402 21.2772 14.21 21.2692C14.2803 21.2577 14.349 21.2378 14.4146 21.21C14.4795 21.1833 14.541 21.149 14.5977 21.1077C14.72 21.0357 14.8219 20.9338 14.8938 20.8115C14.9351 20.7548 14.9695 20.6934 14.9962 20.6285C15.024 20.5629 15.0439 20.4942 15.0554 20.4238C15.0633 20.3541 15.0633 20.2836 15.0554 20.2138C15.0562 20.0721 15.029 19.9316 14.9754 19.8004C14.9219 19.6692 14.8429 19.5499 14.7431 19.4492C14.6989 19.395 14.6503 19.3446 14.5977 19.2985ZM28 14C28 16.7689 27.1789 19.4757 25.6406 21.778C24.1022 24.0803 21.9157 25.8747 19.3576 26.9343C16.7994 27.9939 13.9845 28.2712 11.2687 27.731C8.55301 27.1908 6.05845 25.8574 4.10051 23.8995C2.14258 21.9416 0.809205 19.447 0.269012 16.7313C-0.271181 14.0155 0.00606598 11.2006 1.06569 8.64243C2.12532 6.08427 3.91973 3.89776 6.22202 2.35943C8.52431 0.821086 11.2311 0 14 0C17.713 0 21.274 1.475 23.8995 4.1005C26.525 6.72601 28 10.287 28 14ZM25.8462 14C25.8462 11.6571 25.1514 9.36672 23.8497 7.41863C22.548 5.47054 20.6979 3.95219 18.5333 3.05558C16.3687 2.15897 13.9869 1.92438 11.6889 2.38147C9.39101 2.83855 7.28022 3.96679 5.62351 5.6235C3.9668 7.28022 2.83856 9.391 2.38147 11.6889C1.92439 13.9869 2.15898 16.3687 3.05559 18.5333C3.95219 20.6979 5.47054 22.548 7.41863 23.8497C9.36672 25.1514 11.6571 25.8461 14 25.8461C17.1418 25.8461 20.1549 24.5981 22.3765 22.3765C24.5981 20.1549 25.8462 17.1418 25.8462 14Z"
      fill="#32B6BB"
    />
  </svg>
);

export const ChatBlockTypes = {
  DIAGNOSIS: {
    title: 'Diagnosis',
    label: 'Diagnosis',
    icon: diagIcon,
    primaryColor: '#46BEAF',
    secondaryColor: '#EAFDFB',
  },
  REFLECTION_QUESTION: {
    primaryColor: '#46BEAF',
    secondaryColor: '#EAFDFB',
  },
  INFO: {
    primaryColor: '#46BEAF',
    secondaryColor: '#EAFDFB',
  },
};

const ChatBlock = (props) => {
  return (
    <Styled.Block>
      {(props.chatBlockType.icon ||
        props.chatBlockType.title ||
        props.chatBlockType.label) && (
        <Styled.BlockTitleArea>
          {props.chatBlockType.icon && (
            <Styled.IconWrapper color={props.chatBlockType.secondaryColor}>
              <Icon
                width="20px"
                height="20px"
                icon={props.chatBlockType.icon}
                color={props.chatBlockType.primaryColor}
              />
            </Styled.IconWrapper>
          )}
          {props.chatBlockType.title && (
            <TextLabel type={TextLabelTypes.DARK_BOLD}>
              {props.chatBlockType.title}
            </TextLabel>
          )}
          {props.chatBlockType.label && (
            <Styled.LabelWrapper color={props.chatBlockType.secondaryColor}>
              <TextLabel type={TextLabelTypes.DARK_BOLD}>
                {props.chatBlockType.label}
              </TextLabel>
            </Styled.LabelWrapper>
          )}
        </Styled.BlockTitleArea>
      )}
      {props.children}
    </Styled.Block>
  );
};

ChatBlock.propTypes = {
  children: PropTypes.node.isRequired,
  chatBlockType: PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.node,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
  }).isRequired,
};

export default ChatBlock;
